import React, { Component } from "react";

import { getStaticUrl } from "js/config";
import Logos from "js/core/models/logos";
import { _ } from "js/vendor";
import { PREDEFINED_PALETTES } from "common/constants";
import { GenerateThemeThumbnail } from "../GenerateThemeThumbnail";
import { ChooseThemePaneThumbnail } from "./ThemeThumbnail/components/ChooseThemePaneThumbnail";
import { ThemeCardThumbnail } from "./ThemeThumbnail/components/ThemeCardThumbnail";

import getLogger from "js/core/logger";

const logger = getLogger();

export class ThemeThumbnail extends Component {
    lastFetchedLogoPath;

    state = {
        url: null,
        isRollover: false
    }

    constructor() {
        super();

        this.ref = React.createRef();
    }

    async componentDidMount() {
        const { item: theme } = this.props;

        this.loadThemeThumbnail(theme);
    }

    componentDidUpdate(prevProps) {
        if (this.props.item !== prevProps.item) {
            this.loadThemeThumbnail(this.props.item);
        }
    }

    loadThemeThumbnail = async theme => {
        if (theme.get("isBuiltIn")) {
            const url = getStaticUrl(`/builtinThemes/new/${theme.id}.svg`);
            this.setState({ url });
        } else {
            try {
                theme.on("change", this.handleThemeChange);

                // if we do not have a thumbnail we need to generate one
                let thumbnailId = theme.get("thumbnailId");
                if (!thumbnailId) {
                    thumbnailId = await GenerateThemeThumbnail(theme.attributes);
                    theme.update({ thumbnailId });
                }

                // We shouldn't encounter a case of a theme without a thumbnail, but just in case
                const url = thumbnailId ? await Logos.getSignedUrlAndLoad(thumbnailId) : null;

                this.setState({ url });
            } catch (err) {
                logger.error(err, "ThemeThumbnail componentDidMount() failed", { themeId: theme?.id });
            }
        }
    }

    componentWillUnmount() {
        const { item: theme } = this.props;

        theme.off("change", this.handleThemeChange);
    }

    handleThemeChange = () => {
        this.forceUpdate();
    }

    handleDeleteTheme = () => {
        const { item: theme } = this.props;
        this.props.onDeleteTheme(theme);
    }

    handleMouseEnter = event => {
        this.setState({ isRollover: true });
    }

    handleMouseLeave = event => {
        this.setState({ isRollover: false });
    }

    render() {
        let { item: theme, onClick, onDoubleClick, selected, isDowngraded, hideBar = false, menu, themeThumbnailGrid } = this.props;
        let { url, isRollover } = this.state;

        let backgroundColor = theme.getColors()[theme.get("defaultBackgroundColor") ?? "background_light"];

        let palette;
        if (theme.get("palette_name") != "custom") {
            let predefinedPalette = _.find(PREDEFINED_PALETTES, { id: theme.get("palette_name") || "colorful" });
            if (!predefinedPalette) {
                predefinedPalette = _.find(PREDEFINED_PALETTES, { id: "colorful" });
            }

            palette = predefinedPalette.colors;
        } else {
            palette = theme.get("colors");
        }

        let colors = [palette.theme];
        for (let key of Object.keys(palette)) {
            if (key.startsWith("accent")) {
                colors.push(palette[key]);
            }
        }

        const showBar = !theme.get("isBuiltIn") && !hideBar;
        const isHiddenTheme = theme.get("hidden") && theme.has("orgId");

        // We want to keep current UI for the theme thumbnail grid while changing the UI for selecting themes from the Team Resources
        return themeThumbnailGrid ? (<ChooseThemePaneThumbnail
            ref={this.ref}
            theme={theme}
            onClick={onClick}
            onDoubleClick={onDoubleClick}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            showBar={showBar}
            menu={menu}
            selected={selected}
            url={url}
            backgroundColor={backgroundColor}
            isDowngraded={isDowngraded}
            colors={colors}
            isHiddenTheme={isHiddenTheme}
        />
        ) : (<ThemeCardThumbnail
            ref={this.ref}
            theme={theme}
            onClick={onClick}
            onDoubleClick={onDoubleClick}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            menu={menu}
            isRollover={isRollover}
            onCloseMenu={() => this.setState({ isRollover: false })}
            showBar={showBar}
            selected={selected}
            url={url}
            backgroundColor={backgroundColor}
            isDowngraded={isDowngraded}
            colors={colors}
            isHiddenTheme={isHiddenTheme}
        />
        );
    }
}
